import React from 'react';
import BaseGrid from 'components/atoms/base-grid';
import SmsCampaignsPageHeader from 'components/organisms/sms-campaigns/page-header';
import SmsCampaignSummary from 'components/organisms/sms-campaigns/summary';
import { useSmsCampaignsResponseQueryFilter } from 'infrastructure/hooks/sms-campaigns/use-sms-campaigns-responses-query-filter';
import { useLocation, useParams } from 'react-router-dom';
import { isValidGuid } from 'infrastructure/functions';

import s from './styles.module.scss';

const SmsCampaignSummaryPage: React.FC = () => {
  const { campaignGuid } = useParams();
  if (!campaignGuid || !isValidGuid(campaignGuid)) {
    return null;
  }
  const { state } = useLocation();
  const { filter } = useSmsCampaignsResponseQueryFilter();

  return (
    <BaseGrid className={s.wrapper} rowGap={40}>
      <SmsCampaignsPageHeader campaignGuid={campaignGuid} name={state?.name} />
      <SmsCampaignSummary filters={filter} campaignGuid={campaignGuid} />
    </BaseGrid>
  );
};

export default SmsCampaignSummaryPage;
